import { render } from "./social-networks.vue?vue&type=template&id=2fa1f680&scoped=true"
const script = {}

import "./social-networks.vue?vue&type=style&index=0&id=2fa1f680&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa1f680"]])

export default __exports__